import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import Footer from "./footer"
import Seo from "./seo"
import Instagram from "./instagram"
import Newsletter from "./newsletter"

const Layout = ({ children, page }) => {
  const data = useStaticQuery(graphql`
    query SiteLayoutQuery {
      general: sanitySettingsGeneral {
        siteTitle
        siteURL
        id
        logo {
          asset {
            altText
            gatsbyImageData
          }
        }
      }
      header: sanitySettingsHeader {
        id
        menuDesktopPrimary {
          id
          title
          slug {
            current
          }
          items {
            ... on SanityNavDropdown {
              _key
              _type
              title
              page {
                id
                title
                _type
                slug {
                  _type
                  current
                }
              }
              dropdownItems {
                ... on SanityNavLink {
                  _key
                  _type
                  title
                  url
                }
                ... on SanityNavPage {
                  _key
                  _type
                  title
                  page {
                    ... on SanityLocations {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                    ... on SanityPage {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                    ... on SanityCareers {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                    ... on SanityBlog {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                  }
                }
              }
            }
            ... on SanityNavLink {
              _key
              _type
              url
              title
            }
            ... on SanityNavPage {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  title
                  slug {
                    current
                    _type
                  }
                }
                ... on SanityLocations {
                  id
                  slug {
                    current
                    _type
                  }
                  title
                }
                ... on SanityCareers {
                  id
                  slug {
                    current
                    _type
                  }
                  title
                }
                ... on SanityBlog {
                  id
                  slug {
                    current
                    _type
                  }
                  title
                }
              }
            }
          }
        }
        menuDesktopSecondary {
          id
          title
          slug {
            current
          }
          items {
            ... on SanityNavDropdown {
              _key
              _type
              title
              page {
                id
                title
                _type
                slug {
                  _type
                  current
                }
              }
              dropdownItems {
                ... on SanityNavLink {
                  _key
                  _type
                  title
                  url
                }
                ... on SanityNavPage {
                  _key
                  _type
                  title
                  page {
                    
                    ... on SanityPage {
                      id
                      title
                      slug {
                        current
                        _type
                      }
                      _type
                    }
                    ... on SanityLocations {
                      id
                      title
                      slug {
                        current
                        _type
                      }
                      _type
                    }
                    ... on SanityCareers {
                      id
                      title
                      slug {
                        current
                        _type
                      }
                      _type
                    }
                    ... on SanityBlog {
                      id
                      title
                      slug {
                        current
                        _type
                      }
                      _type
                    }
                  }
                }
              }
            }
            ... on SanityNavLink {
              _key
              _type
              url
              title
            }
            ... on SanityNavPage {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  title
                  slug {
                    current
                    _type
                  }
                  _type
                }
                ... on SanityLocations {
                  id
                  slug {
                    current
                    _type
                  }
                  title
                  _type
                }
              }
            }
          }
        }
      }
      footer: sanitySettingsFooter {
        id
        siteInfoTitle
        siteInfoTagline
        siteInfoImage {
          asset {
            altText
            gatsbyImageData
          }
        }
        socialMenuTitle
        social {
          icon
          url
          _type
          _key
        }
        primaryMenuTitle
        primaryMenu {
          id
          title
          slug {
            _key
            _type
            current
          }
          items {
            ... on SanityNavDropdown {
              _key
              _type
              title
              page {
                id
                title
                slug {
                  _type
                  current
                }
              }
              dropdownItems {
                ... on SanityNavLink {
                  _key
                  _type
                  title
                  url
                }
                ... on SanityNavPage {
                  _key
                  _type
                  title
                  page {
                    ... on SanityLocations {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                  }
                }
              }
            }
            ... on SanityNavLink {
              _key
              _type
              url
              title
            }
            ... on SanityNavPage {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  title
                  slug {
                    current
                  }
                }
                ... on SanityLocations {
                  id
                  slug {
                    current
                  }
                  title
                }
              }
            }
          }
        }
        secondaryMenuTitle
        secondaryMenu {
          title
          id
          items {
            ... on SanityNavDropdown {
              _key
              _type
              title
              page {
                id
                title
                slug {
                  _type
                  current
                }
              }
              dropdownItems {
                ... on SanityNavLink {
                  _key
                  _type
                  title
                  url
                }
                ... on SanityNavPage {
                  _key
                  _type
                  title
                  page {
                    ... on SanityLocations {
                      id
                      title
                      slug {
                        current
                      }
                      _type
                    }
                  }
                }
              }
            }
            ... on SanityNavLink {
              _key
              _type
              url
              title
            }
            ... on SanityNavPage {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  title
                  _type
                  slug {
                    current
                  }
                }
                ... on SanityLocations {
                  id
                  _type
                  slug {
                    current
                  }
                  title
                }
              }
            }
          }
        }
      }
      cookie: sanitySettingsCookie {
        id
        message
        enabled
        link {
          id
          title
          slug {
            current
          }
        }
      }
      promo: sanitySettingsPromo {
        id
        text
        link {
          id
          title
          slug {
            current
          }
        }
      }
      seo: sanitySettingsSeo {
        id
        metaTitle
        metaDesc
        shareTitle
        shareDesc
        shareGraphic {
          asset {
            id
            altText
            gatsbyImageData
          }
        }
        favicon {
          asset {
            altText
            id
            gatsbyImageData
          }
        }
        faviconLegacy {
          asset {
            id
            altText
            url
          }
        }
      }
      settingsInstagram: sanitySettingsInstagramGallery {
        title
        desc
        imageTextCarouselItem {
          image {
            _key
            asset {
              altText
              gatsbyImageData
            }
          }
        }
      }
      settingsNewsletter: sanitySettingsNewsletterModule {
        title
        desc
      }
    }
  `)

  const { general, header, footer, cookie, promo, seo, settingsInstagram, settingsNewsletter } = data


  return (
    <>
      <Seo seo={seo} page={page}/>
      {/* <Header header={header} site={general} className="w-1/5 fixed inset-0 z-50" /> */}
      <Header header={header} site={general}  />

      {/* <main className="flex before:content[''] before:w-1/5 before:block">
        <div className="flex flex-col flex-1">
          {children}
        </div>
      </main> */}

      <main className="">{children}</main>

      <Instagram instagram={settingsInstagram} />
      {/* <Newsletter newsletter={settingsNewsletter} /> */}
      <Footer footer={footer} site={general} />
    </>
  )
}

export default Layout
